import React, { useEffect, useState } from 'react'
import '../../Styles/ProfileIcon.css'
import { useProfileStore } from '../../Containers/MainContainer/Store/ProfileStore'
import { get } from 'src/Containers/Auth/Store/Store'
const ProfileIcon = ({ handleClickProfile }) => {
    const userName = get('userName')
    const userprofileData = get('profilePic')
    const userProfileName = userName?.split('Mr.')[1] || userName?.split('Mrs.')[1] || userName?.split('Ms.')[1] || userName?.split('Mx.')[1] || userName?.split('Dr.')[1] || userName
    
    const getInitial = name => {
        const [firstName, lastName] = name?.split(' ')

        if (firstName && lastName) {
          return `${firstName?.charAt(0)}${lastName?.charAt(0)}`?.toUpperCase()
        }
      
        return firstName?.charAt(0)?.toUpperCase()
    }
    return (
        <div className='border-initialsavatar' onClick={handleClickProfile}>
            <div
                aria-label={name}
                role="img"
                className={'initials-avatar'}
            >
                {/* {(userprofileData && userprofileData !== 'null' && !userprofileData.includes('data:null;base64, null'))
                    ? <img style={{ width: '100%', height: '100%', borderRadius: '50%' }} src={userprofileData} />
                    : <div>{getInitial(userProfileName || "John Rampo" )}</div>
                } */}
                {(!userprofileData)
                    ? <div>{getInitial(userProfileName || "John Rampo" )}</div>
                    : <img style={{ width: '100%', height: '100%', borderRadius: '50%' }} src={userprofileData} />
                }

            </div>
        </div>
            )
}

export default ProfileIcon